import * as React from 'react';
import { SVGProps } from 'react';

const SvgTask = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#clip0_5129_9053)'>
      <path d='M22.5 16H12V17.5H22.5V16Z' fill='#000' />
      <path
        d='M10.5 14.05L9.45 13L4.5 17.95L2.55 16L1.5 17.05L4.5 20.05L10.5 14.05Z'
        fill='#000'
      />
      <path d='M22.5 5.5H12V7H22.5V5.5Z' fill='#000' />
      <path
        d='M10.5 3.55L9.45 2.5L4.5 7.45L2.55 5.5L1.5 6.55L4.5 9.55L10.5 3.55Z'
        fill='#000'
      />
    </g>
  </svg>
);

export default SvgTask;
